import React from "react";
import { useAppContext } from "../../context/appContext";

const MenuOptionItem = (props) => {
    const { setItems, setType, isLoading } = useAppContext();

    const selectHandler = () => {
        if (isLoading) return;
        setType(props.type);
    };

    return (
        <div
            className={`flex h-[5rem] min-w-[150px] flex-1 flex-grow-0 cursor-pointer  items-center  justify-center self-stretch rounded-lg text-lg font-thin uppercase ${
                props.active ? "bg-main-100  text-main-800" : "bg-main-800"
            }`}
            onClick={selectHandler}
        >
            {props.type}
        </div>
    );
};

export default MenuOptionItem;
